import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'
import * as entry from '../entry'

/**
 * A feed showing previous check-ins
 */
@ngCore.Component({
  imports: [
    ds.illustration.emptyState.Component,
    entry.Component,
    ds.loader.Component,
  ],
  selector: 'atn-summit-check-ins-feed',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component implements ngCore.OnInit {
  /** @see {@link state.summit.checkIn.Feature} */
  public readonly checkInFeature = ngCore.inject(state.summit.checkIn.Feature)

  /**
   * Conveys to {@link state.summit.pulse.Feature} that the user has opened this
   * page
   */
  public ngOnInit(): void {
    this.checkInFeature.actions.viewFeed
      .from('SummitCheckInFeed.OnInit')
      .dispatch()
  }
}
